<template>
  <div class="active-rules">
    <div class="header">
      <TopBar :title ="title" />
    </div>
    <div class="content">
      <div class="content-body">
        <p>{{$t("guize.title")}}</p>
        <p>{{$t("guize.content1")}}</p>
        <p>{{$t("guize.content2")}}</p>
        <p>{{$t("guize.content3")}}</p> 
        <p>{{$t("guize.content4")}}</p> 
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Notify } from 'vant';
  import TopBar from '@/common/top-bar/index.vue'

  export default {
    name: 'ActiveRules',
    components: {
      TopBar
    },
    data () {
      return {
        title:this.$t("helpEarn.huodong")
      }
    },
    methods: {
    },
    mounted () {
    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.active-rules{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #F3F3F3;
    .header{
    }
    .content{
      background-color:#F3F3F3;
      
      .content-body{
        border-radius:18px;
        margin: 30px 20px 20px;
        background:#fff;
        padding:10px;
        p:nth-child(1){
          font-size:18px;
          line-height:60px;
          color:#FF7532
        }
        p:nth-child(2){
          font-size:16px;
          line-height:30px;
       
        }
        p:nth-child(3){
          font-size:16px;
          line-height:30px;
  
        }
        p:nth-child(4){
          font-size:16px;
          line-height:30px;
   
        }
        p:nth-child(5){
          font-size:16px;
          line-height:30px;
 
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/activeRules/ActiveRules.vue